// Javascript Animations
const animController = new ScrollMagic.Controller({
    addIndicators: false,
});

let animationTrigger = (timeline, element, type, timing) => {
    if (!timing) {
        timing = '-=0.75';
    }

    switch (type) {
        case 'fadeUp':
            timeline.from(element, 1, { y: 100, opacity: 0 }, timing);
            break;
        case 'fadeLeft':
            timeline.from(element, 1, { x: 100, opacity: 0 }, timing);
            break;
        case 'fadeRight':
            timeline.from(element, 1, { x: -100, opacity: 0 }, timing);
            break;
        case 'fade':
            timeline.from(element, 1, { opacity: 0 }, timing);
            break;
        default:
            timeline.from(element, 1, { opacity: 0 }, timing);
    }
};

const animatedSections = document.querySelectorAll('.animatedSection');
for (let i = animatedSections.length - 1; i >= 0; i--) {
    let section = animatedSections[i];

    // ANIMATED SECTIONS
    let animatedElements = section.querySelectorAll('.animatedEl');
    let tl = new TimelineMax();
    for (let i = 0; i < animatedElements.length; i++) {
        let el = animatedElements[i];
        let type = el.getAttribute('data-anim');
        let timing = el.getAttribute('data-anim-timing');
        animationTrigger(tl, el, type, timing);
    }

    let animatedScene = new ScrollMagic.Scene({
        triggerElement: section,
        triggerHook: 0.6,
        reverse: false,
    })
        .setTween(tl)
        .addTo(animController);
}
